export const SELECT_PLAN = 'SELECT_PLAN';
export const CLEAR_PLAN = 'CLEAR_PLAN';

export const selectPlan = (plan) => ({
    type: SELECT_PLAN,
    payload: plan
});

export const clearPlan = () => ({ type: CLEAR_PLAN });
